export function filterTransforms(plugins, selectedItems, selectedBundles, allowedBundles) {
  return plugins.filter((plugin) => {
    if (selectedItems.length < plugin.min) {
      return false;
    }
    if (plugin.max !== -1 && selectedItems.length > plugin.max) {
      return false;
    }
    const allAllowedInList = plugin.targetBundles.every(
      (bundle) => allowedBundles.includes(bundle)
    );
    if (!allAllowedInList) {
      return false;
    }
    return selectedBundles.every((bundle) => plugin.bundles.includes(bundle));
  });
}
